import React from 'react';
import { FileIcon } from 'react-file-utils';
import * as Sentry from '@sentry/browser';

import { attachmentPreviewPropTypes } from '../../../utils/attachments';
import { downloadUrlAsFile } from '../../../utils/file';

import { FilePreviewContainer, FileIconContainer, FileTitle } from './styles';

const FileAttachment = ({
  assetLocalUrl,
  attachmentData: {
    title,
    mimeType,
  },
}) => {
  const handleDownload = async () => {
    try {
      await downloadUrlAsFile(assetLocalUrl, title);
    } catch (error) {
      Sentry.captureException(error, {
        extra: {
          assetLocalUrl,
        },
      });
    }
  };

  return (
    <FilePreviewContainer>
      <FileIconContainer onClick={handleDownload}>
        <FileIcon
          mimeType={mimeType}
          size={120}
          filename={title}
          big
        />
      </FileIconContainer>
      <FileTitle>{title}</FileTitle>
    </FilePreviewContainer>
  );
};

FileAttachment.propTypes = attachmentPreviewPropTypes;

FileAttachment.defaultProps = {};

export default FileAttachment;
